import React from 'react';
import { FormSection } from '../../components/forms/FormSection';
import { FormStack } from '../../components/forms/FormStack';
import { HookedKeyContactsControl } from '../../components/forms/HookedKeyContactsControl';
import { FormErrorsAlert } from '../../components/generic/FormErrorsAlert';

interface Props {
  isDisabled?: boolean;
}

export const ParticipantFormKeyContacts = (props: Props) => {
  const { isDisabled } = props;

  return (
    <FormStack>
      <FormErrorsAlert />
      <FormSection heading='Key contacts' description='Key contacts for a participant'>
        <HookedKeyContactsControl name='keyContacts' isDisabled={isDisabled} />
      </FormSection>
    </FormStack>
  );
};
